/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { PlusLargeIcon, TimesIcon } from 'shared/components/Icons';

const PollImageBlock = ({ className, imgClassName, image, title, onClick, onRemoveImage }) => {
  return (
    <div className={`image-upload-block ${className || ''}`}>
      {title && <p className='text-gray-dark text-md mb-8'>{title}</p>}
      {!image && (
        <label
          onClick={onClick}
          className={`border border-primary rounded-6 d-flex align-items-center justify-content-center cursor-pointer ${
            image ? '' : 'py-22'
          }`}
        >
          <PlusLargeIcon className='svg-primary' />
        </label>
      )}
      {image && (
        <div className={`poll-form-image ${imgClassName}`}>
          <button
            className='btn p-0 remove-btn d-flex align-items-center justify-content-center'
            onClick={onRemoveImage}
          >
            <TimesIcon className='svg-white' />
          </button>
          <img src={image} alt='img' />
        </div>
      )}
    </div>
  );
};

export default PollImageBlock;
